import { query } from '@confluence/query-preloader-tools';

import { preloadOptions } from '../Options/preloadOptions';
import { HOME_STARRED_PAGES_QUERY_TASK_NAME } from '../Options/constants';

import { getStarredQueryOptions } from './starredQueryHelpers';

export const preloadStarred = ({ isLoggedIn, bestEffortTask }) => {
	bestEffortTask(HOME_STARRED_PAGES_QUERY_TASK_NAME, () => query(getStarredQueryOptions()));
	return preloadOptions({ isLoggedIn });
};
